export const WORKFLOW_PERMISSION_CODES = {
    WEB_OFFICE_WORKFLOW_LIST: 'WEB_OFFICE_WORKFLOW_LIST',
    WEB_OFFICE_WORKFLOW_DETAIL: 'WEB_OFFICE_WORKFLOW_DETAIL',
    WEB_OFFICE_WORKFLOW_ADD: 'WEB_OFFICE_WORKFLOW_ADD',
    WEB_OFFICE_WORKFLOW_EDIT: 'WEB_OFFICE_WORKFLOW_EDIT',
    WEB_OFFICE_WORKFLOW_DELETE: 'WEB_OFFICE_WORKFLOW_DELETE',
} as const;

